export default __webpack_public_path__ + "static/media/reset-password.4a60c3f5.png";